'use client';
import { useMemo, useEffect } from 'react';
import { useSessionStorage, useDidUpdate } from '@s7/hooks';
import { fnv1aBMr36 } from '@s7/utils';
import { client } from '../client.js';
import { useQuery } from '../../../../common/client/useQuery.js';

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var useContentQuery = function(options, handlers) {
    var url = options.url, cache = options.cache, code = options.code, device = options.device, lang = options.lang;
    var key = useMemo(function() {
        return "footer-" + fnv1aBMr36(url + code + device + lang);
    }, [
        url,
        code,
        device,
        lang
    ]);
    var _useSessionStorage = useSessionStorage({
        key: key,
        defaultValue: null,
        /* Необходимо для корректной работы механизма восстановления из кэша */ getInitialValueInEffect: false
    }), cachedData = _useSessionStorage[0], setCachedData = _useSessionStorage[1];
    var restoreFromCache = cache && cachedData !== null;
    var _useQuery = useQuery(/*#__PURE__*/ _async_to_generator(function() {
        return _ts_generator(this, function(_state) {
            return [
                2,
                client.get({
                    url: url,
                    params: {
                        code: code,
                        device: device,
                        lang: lang
                    }
                })
            ];
        });
    }), handlers, {
        skipInitial: restoreFromCache
    }), data = _useQuery.data, refresh = _useQuery.refresh, resource = _object_without_properties_loose(_useQuery, [
        "data",
        "refresh"
    ]);
    useDidUpdate(refresh, [
        url,
        code,
        device,
        lang
    ]);
    useDidUpdate(function() {
        if (!cache) {
            refresh();
        } else if (data) {
            setCachedData(data);
        }
    }, [
        cache
    ]);
    useEffect(function() {
        if (cache && data) {
            setCachedData(data);
        }
    }, [
        data
    ]);
    return _extends({
        data: restoreFromCache ? cachedData : data,
        refresh: refresh
    }, resource);
};

export { useContentQuery };
